import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {riskFactorShape} from '../../shapes';
import RiskFactor from './RiskFactor';

export default function RiskFactorContainer(props) {
	const {riskFactors, sectionId, bodyId, isViewBodyOnly, bodyTypeId, isDisabled} = props;

	return (
		<StyledRiskFactorContainer className="RiskFactorContainer">
			{riskFactors && riskFactors.length !== 0 ? (
				riskFactors.map((riskFactor, i) => {
					return (
						<RiskFactor
							key={`${riskFactor.formBodyOptionActionId}-${i}`}
							riskFactor={riskFactor}
							sectionId={sectionId}
							bodyId={bodyId}
							bodyTypeId={bodyTypeId}
							isViewBodyOnly={isViewBodyOnly}
							isDisabled={isDisabled}
						/>
					);
				})
			) : (
				<>
					<RiskFactor
						riskFactor={riskFactors}
						isViewBodyOnly={isViewBodyOnly}
						bodyTypeId={bodyTypeId}
						bodyId={bodyId}
						sectionId={sectionId}
						isDisabled={isDisabled}
					/>
				</>
			)}
		</StyledRiskFactorContainer>
	);
}

RiskFactorContainer.propTypes = {
	riskFactors: PropTypes.arrayOf(riskFactorShape),
	isVisible: PropTypes.bool,
	sectionId: PropTypes.number.isRequired,
	bodyId: PropTypes.number.isRequired,
	isViewBodyOnly: PropTypes.bool.isRequired
};

const StyledRiskFactorContainer = styled.section`
	display: flex;
	flex-direction: column;
	margin: var(--px-20) 0 0 var(--px-25);
	padding-left: var(--px-32);
	&.notVisbile {
		margin: 0;
		display: none;
	}
	.motif-tooltip-wrapper {
		width: calc(100% - var(--px-30));
	}
	.RiskLabel {
		font-size: var(--px-16);
		line-height: var(--px-24);
		font-weight: 300;
		color: var(--neutrals-900);
		margin-bottom: var(--px-8);
	}
	.RiskInputField {
		display: flex;
		position: relative;
		& + .RiskLabel {
			margin-top: var(--px-30);
		}
		&.greyOutArea {
			.MotifProgressBarWrapper {
				display: flex;
				width: var(--px-700);
				margin-top: 0 !important;
			}
		}
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: 100%;
			.motif-progress-bar-wrapper {
				height: 100%;
				width: 30%;
				z-index: 1;
				justify-content: center;
				.motif-progress-bar {
					width: var(--px-20);
					height: var(--px-20);
				}
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
			}
		}
		.editInputIconWrapper {
			display: flex;
			align-items: center;
			height: var(--px-74);
			padding: var(--px-12) 0 var(--px-5) 0;
			margin-left: var(--px-5);
			.inputMotifIcon {
				color: var(--blue-600);
				font-size: var(--px-14);
				margin-left: var(--px-10);
				svg {
					fill: var(--neutrals-700);
				}
				&.saveBtn {
					svg {
						fill: var(--green-500);
					}
				}
				&.cancelBtn {
					svg {
						fill: var(--red-600);
					}
				}
			}
		}
	}
	.greyOutArea {
		.section-radio,
		.section-checkbox,
		.toggleButton,
		.formBodyOptionSelect,
		.bodyDatePicker,
		.input-group,
		.inputField,
		.risk-factor-description-dropdown,
		label,
		.RiskLabel {
			pointer-events: none;
			opacity: 0.3;
			color: var(--neutrals-900);
		}
		.risk-factor-description-dropdown {
			width: var(--px-700);
		}
	}
	.inputField {
		width: var(--px-900);
		display: inline-flex;
		& + .RiskLabel {
			margin-top: var(--px-20);
		}
		
		.inputEllipsis {
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
		.motif-icon {
			display: flex;
			align-items: center;
			svg {
				width: var(--px-35);
				height: var(--px-28);
				margin-top: var(--px-6);
			}
		}
		.motif-input-component {
			width: 100%;
		}
	}
`;
